import { motion } from "framer-motion";

const familyIssues = [
  "Family Dynamics",
  "Parenting",
  "Child Growth & Development",
  "Attachment",
  "Divorce & Co-Parenting",
  "Learning Differences",
  "ADHD",
];

const individualIssues = [
  "Anxiety & Stress",
  "Depression",
  "Trauma",
  "Grief & Loss",
  "Burnout",
  "Self-Esteem",
  "Relationship Issues",
  "Life Transitions",
  "LGBTQ+ Stress",
];

const TagCloud = ({ title, items, delayOffset = 0 }: { title: string; items: string[]; delayOffset?: number }) => (
  <div className="mb-10 last:mb-0">
    <h3 className="text-lg font-heading font-medium text-foreground mb-4 text-center">{title}</h3>
    <div className="flex flex-wrap justify-center gap-3">
      {items.map((issue, index) => (
        <motion.span
          key={issue}
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, delay: (delayOffset + index) * 0.05 }}
          className="issue-tag px-5 py-2.5 bg-secondary text-foreground rounded-full font-body text-sm font-medium tracking-wide"
        >
          {issue}
        </motion.span>
      ))}
    </div>
  </div>
);

const IssuesSection = () => {
  return (
    <section id="issues" className="issues-section py-24 px-6 bg-background">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="issues-heading text-3xl md:text-4xl font-heading font-medium text-foreground mb-4">
            Types of Issues We Cover
          </h2>
          <div className="w-16 h-px bg-accent mx-auto mb-10" />
          <TagCloud title="Individual" items={individualIssues} />
          <TagCloud title="Family & Children" items={familyIssues} delayOffset={individualIssues.length} />
        </motion.div>
      </div>
    </section>
  );
};

export default IssuesSection;
